import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a768b34"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "header-timeDistribution"
}
const _hoisted_2 = ["id"]

import { onMounted, ref, watch } from "vue";
import * as am5 from "@amcharts/amcharts5";
import { Root, Legend } from "@amcharts/amcharts5";
import { PieChart, PieSeries } from "@amcharts/amcharts5/percent";
import AnimatedTheme from "@amcharts/amcharts5/themes/Animated";
import { Color } from "@amcharts/amcharts5/.internal/core/util/Color";
import am5lang_es_ES from "@amcharts/amcharts5/locales/es_ES";

export default /*#__PURE__*/_defineComponent({
  props: {
    idChart: null,
    probability: null,
    title: null
  },
  setup(__props: any) {

const props = __props as {
  idChart: string;
  probability:
    | Array<{
        name: string;
        value: number;
        tmoa: string;
        strokeSettings?: { fill: Color; stroke: Color };
      }>
    | undefined;
  title: string | undefined;
}


const series = ref<PieSeries>();
const legend = ref<Legend>();
let root: am5.Root | null = null;

onMounted(() => {
  redrawCharts();
});

const redrawCharts = () => {
  // Recalcular datos

  if (root) {
    root.dispose();
  }

  // Crear nuevo gráfico
  createChart();
};

const createChart = () => {
  root = Root.new(props.idChart);
  root.locale = am5lang_es_ES;
  root.numberFormatter.set("intlLocales", "es");

  // Apply animated theme
  root.setThemes([AnimatedTheme.new(root)]);

  // Create pie chart
  const chart = root.container.children.push(
    PieChart.new(root, {
      layout: root.verticalLayout,
      // innerRadius: percent(50), // Quitar para que sea donut
    })
  );

  // Create and configure series
  series.value = chart.series.push(
    PieSeries.new(root, {
      valueField: "value",
      categoryField: "name",
      alignLabels: false,
    })
  );

  // Quitar eventos
  root.interactionsEnabled = false;
  series.value.slices.template.set("interactive", false);

  //- Poner en rojo la franja
  series.value.slices.template.set("templateField", "strokeSettings");
  // Tooltip
  series.value.slices.template.adapters.add("tooltipText", (text, target) => {
    const data = target.dataItem?.dataContext as any;
    const percentage = data.value != null ? `${data.value.toFixed(2)} %` : "";
    return data?.tmoa ? `${data.tmoa}: ${percentage}` : `${data.name}: ${percentage}`;
  });

  // Set data

  // Filtra SOLO para la serie (que no grafique ceros)
  const seriesData =
    props.probability.length > 0 ? props.probability.filter((item) => item.value > 0) : [];

  // Setear los datos filtrados al gráfico
  series.value.data.setAll(seriesData);

  // Ocultar las lineas que salen de la grafica
  series.value.ticks.template.setAll({ forceHidden: true });
  series.value.labels.template.setAll({ forceHidden: true });

  //- Leyenda
  // Create and set legend data
  let legend = chart.children.push(
    am5.Legend.new(root, {
      centerX: am5.percent(50),
      x: am5.percent(50),
      layout: root.verticalLayout,
      marginTop: 5,
      marginBottom: 5,
    })
  );

  // Reducir tamaño
  legend.labels.template.setAll({
    fontSize: 11,
    maxWidth: 120,
    oversizedBehavior: "truncate",
  });

  legend.itemContainers.template.setAll({
    paddingTop: 2,
    paddingBottom: 2,
  });

  // ASÍ SE HACE EN AMCHARTS 5
  if (props.probability && props.probability.length > 0) {
    legend.data.setAll(series.value.dataItems);
  }

  // Play initial animation
  series.value.appear(1000, 100);
};

watch(
  () => [...props.probability],
  () => {
    console.log("CAMBIAAA DONUT");
    redrawCharts();
  },
  { deep: true, immediate: false }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("p", null, _toDisplayString(__props.title), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      id: __props.idChart,
      style: {"width":"100%","height":"46vh"}
    }, null, 8, _hoisted_2)
  ], 64))
}
}

})